// import type from 'postcss-pxtorem/lib/type'
import requests from '../request'

// 'Contont-type': 'application/json'
// 'Contont-type': 'application/x-www-form-urlencoded'

// 首页 信息
export const reportHomeList = (data) => {
  return requests({
    url: '/api/info/report/homeList',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 事件
export const eventCountDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/eventCountData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 资源菜单 菜单
export const integratedQueryGetResourceIndexAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/getResourceIndex',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 资源菜单 资源数据
export const integratedQueryGetResourcesAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/getResources',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 报警
export const eventGetNewEventCountAPI = (params) => {
  return requests({
    // url: '/api/base/event/getNewEventCount',
    url: '/api/emergencyevent/getNewEventCount',
    method: 'post',
    data:params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 危险源 隐患
export const informationCountDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/informationCountData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 首页 事件列表
export const eventListAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/eventData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 首页 危险源列表
export const weixianyuanListAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/wxyData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 首页 隐患列表
export const yinhuanListAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/yhData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

export const yingjizhuangbeiListAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/zbData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 首页 资源(bar)
export const resourceDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/resourceData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 救援队伍(bar)
export const jydDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/jydData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 专家(bar)
export const zjDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/zjData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}


// 首页 bar 事件
export const eventDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/eventData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 bar 危险源
export const wxyDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/wxyData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 bar 隐患
export const yhDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/yhData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 bar 隐患
export const zbDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/zbData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 首页 bar 物资
export const wzDataAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/wzData',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}


// 首页 打点 获取周边资源
export const showSurroundingResourcesAPI = (params) => {
  return requests({
    url: '/api/resourceNew/showSurroundingResources',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })

}
// 首页 打点 弹窗信息
export const getNodeTextAPI = (params) => {
  return requests({
    url: '/api/integratedQuery/getNodeText',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}



// 首页 
export const getUserMapAPI = (data) => {
  return requests({
    url: '/api/map/getUserMap',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json;charset=utf-8'
    }
  })
}



// 首页 
export const getNewEventCountAPI = (data) => {
  return requests({
    url: '/api/event/getNewEventCount',
    method: 'GET',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 获取在线网格员 点位信息 
export const PositionList = (params) => {
  return requests({
    url: '/api/position/role/get',
    method: 'get',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
export const schedulingIndexGetApi = (params) => {
  return requests({
    url: '/api/scheduling/index/get',
    method: 'get',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 删除极光信息 
export const DelectJg = (data) => {
  return requests({
    url: '/api/position/delete',
    method: 'post',
    data: {},
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
